import React from 'react'
import { View, Text, Icon } from '../primitives'

const Container = View.extend.attrs({ m: 1, pl: 2, pr: 1 })`
  display: inline-flex;
  height: ${({ theme: { space } }) => space[4]}px;
  align-items: center;
  background-color: ${({ theme: { colors } }) => colors.accent3Color};
  border: 1px solid ${({ theme: { colors } }) => colors.borderColor};
  border-radius: ${({ theme: { radii } }) => radii[1]}px;
`

const Button = View.extend.attrs({
  p: 1,
  ml: 1
})`
  display: inline-flex;
  cursor: pointer;
`

const RemoveIcon = Icon.extend.attrs({ icon: 'remove', size: 16 })`
  color: ${({ theme: { colors } }) => colors.primary3Color};
  &:hover {
    color: ${({ theme: { colors } }) => colors.primary3HoverColor};
  }
`

export default ({ children, onClick }) => (
  <Container>
    <Text>{children}</Text>
    <Button onClick={onClick}>
      <RemoveIcon />
    </Button>
  </Container>
)
